import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=58280272&scoped=true&"
import script from "./Menu.ts?vue&type=script&lang=ts&"
export * from "./Menu.ts?vue&type=script&lang=ts&"
import style0 from "./Menu.scss?vue&type=style&index=0&id=58280272&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58280272",
  null
  
)

export default component.exports